import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

interface PaymentModeDetailApiResponse {
    paycode: string;
    paystno: string;
    payDispno?: number | null;
}

export interface PaymentModeDetailResponse {
    paycode: string;
    paystno: string;
    payDispno: number;
}

export const getAllPaymentModeDetails = async (): Promise<PaymentModeDetailResponse[]> => {
    try {
        const response: ApiResponse<PaymentModeDetailApiResponse[] | null> = (
            await apiClient.get("/pos_paymodedet/all", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return (response.data || []).map((detail) => ({
            paycode: detail.paycode,
            paystno: detail.paystno,
            payDispno: Math.max(0, Math.trunc(Number(detail.payDispno) || 0)),
        }));
    } catch (error: any) {
        if (error?.response?.status === 401) {
            throw new Error("Not authorized to load payment card types. Please sign in with backend authentication.");
        }

        if (error?.response?.data?.detail) {
            const detail = error.response.data.detail;
            const message = typeof detail === "string" ? detail : JSON.stringify(detail);
            throw new Error(message);
        }

        throw new Error("Failed to fetch payment card types");
    }
};
